import { render } from "./pdfUpload.vue?vue&type=template&id=bd75ae10"
import script from "./pdfUpload.vue?vue&type=script&lang=js"
export * from "./pdfUpload.vue?vue&type=script&lang=js"

import "./pdfUpload.vue?vue&type=style&index=0&id=bd75ae10&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__